import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';
import type { ClientType } from '../types/api';

interface AudienceContextType {
  selectedAudience: ClientType | null;
  setAudience: (audience: ClientType | null) => void;
}

const AudienceContext = createContext<AudienceContextType | undefined>(undefined);

export function AudienceProvider({ children }: { children: ReactNode }) {
  const [selectedAudience, setSelectedAudience] = useState<ClientType | null>(null);

  return (
    <AudienceContext.Provider value={{ selectedAudience, setAudience: setSelectedAudience }}>
      {children}
    </AudienceContext.Provider>
  );
}

export function useAudience() {
  const context = useContext(AudienceContext);
  if (!context) {
    throw new Error('useAudience must be used within an AudienceProvider');
  }
  return context;
}
